// Module
var code = "<p>Since your loan payment happens automatically, it&#39;s never late so long as funds are available.</p> ";
// Exports
export default code;